import { useTranslation } from "@redotech/redo-i18n";
import QrCode from "@redotech/redo-icons/qr-code-01.svg";
import { BlueYonderZod } from "@redotech/redo-model/return";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { BlueYonderLocationsButton } from "./blue-yonder-locations-button";

export const BlueYonderQRCard = memo(function BlueYonderQRCard({
  blueYonderQRCodes,
  returnId,
  autoOpen = false,
}: {
  blueYonderQRCodes: BlueYonderZod["returns"];
  returnId: string;
  autoOpen?: boolean;
}) {
  const { t } = useTranslation();
  const qrCodeUri = blueYonderQRCodes[0]?.qrCodeUri;

  if (!blueYonderQRCodes.length) {
    return null;
  }

  return (
    <>
      <Flex>
        <RedoButton
          hierarchy="secondary"
          IconLeading={QrCode}
          onClick={() => qrCodeUri && window.open(qrCodeUri, "_blank")}
          text={t("QR code")}
        />
      </Flex>
      <BlueYonderLocationsButton autoOpen={autoOpen} returnId={returnId} />
    </>
  );
});
